import PropTypes from 'prop-types'
import React, { useCallback, useState, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import * as tiendasOficialesService from '../../servicios/tiendasOficialesService'

const Upload = ({ idTiendaOficial, accept, esBanner, onCerrarModal }) => {
  const [imagenes, setImagenes] = useState([])

  useEffect(() => {
    const obtenerAdjuntos = async () => {
      const imagenes = await tiendasOficialesService.buscarAdjuntos(
        idTiendaOficial,
        esBanner
      )
      setImagenes(imagenes.data)
    }
    obtenerAdjuntos()
  }, [esBanner, idTiendaOficial])

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.map((archivo) => {
        upload(idTiendaOficial, archivo).then(() => {
          tiendasOficialesService.buscarAdjuntos(idTiendaOficial, esBanner).then((a) => {
            setImagenes(a.data)
          })
        })

        return archivo
      })
    },
    [esBanner, idTiendaOficial]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept })

  const upload = async (idTiendaOficial, archivo) => {
    const tiendaOficial = new FormData()
    tiendaOficial.append('nombre', archivo.name)
    tiendaOficial.append('idTiendaOficial', idTiendaOficial)
    tiendaOficial.append('archivo', archivo)
    tiendaOficial.append('esBanner', esBanner)
    onCerrarModal(esBanner)

    await tiendasOficialesService.subirArchivo(tiendaOficial)
  }

  return (
    <>
      <div className="borde-hormiga text-center" {...getRootProps()}>
        <i className="fa fa-camera fa-2x" aria-hidden="true" />
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Soltá las fotografías acá...</p>
        ) : (
          <p>Agregá las fotografías desde tu computadora o arrastralas acá</p>
        )}
      </div>

      <div className="row-img-subida">
        <div className="row">
          {imagenes &&
            imagenes.map((a) => (
              <div className="col-6 col-xl-3" key={a.idAdjunto}>
                <div className="row">
                  <div className="col-12">
                    <div className="cont-img-subida">
                      <img
                        alt={`img - ${a.nombre}`}
                        src={a.path}
                        className="subida-img"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col nombre-img-subida">
                    <p>{a.nombre}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}

Upload.propTypes = {
  idTiendaOficial: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  accept: PropTypes.object,
  esBanner: PropTypes.bool.isRequired,
  onCerrarModal: PropTypes.func.isRequired
}

export default React.memo(Upload)
